import { NewsCategory } from '@fe-news/constants/categories';

export type AiArticleType = 'headline' | 'tw_stock' | 'us_stock';

type AiArticleSource = 'US_Stock_Summary' | 'TW_Stock_Summary' | 'Headline_Summary';

export type GETv1AiArticlesResponse = {
  source: AiArticleSource;
  summary: string;
  created_at: number;
  related: RelativeNews;
  title: string;
};

export type GETv1AiArticlesReturnResponse = {
  source: AiArticleSource;
  summary: string;
  createdAt: number;
  related: RelativeNews;
  title: string;
};

export const DEFAULT_AI_CONTENT = {
  title: '',
  summary: '',
  source: 'US_Stock_Summary' as AiArticleSource,
  createdAt: 0,
  related: []
};

export type ResponseAiArticleType = {
  items: GETv1AiArticlesResponse;
  message: string;
  statusCode: number;
};

export type RelativeNews = Pick<News, 'title' | 'newsId'>[];

export type GETAiArticlesResponseV2 = {
  content: string;
  feature: number;
  hasCoverPhoto: number;
  is24h: number;
  isCategoryHeadline: number;
  isIndex: number;
  isOutsource: number;
  keyword: string[];
  newsId: number;
  otherProduct: string[];
  payment: number;
  source: string;
  stock: string[];
  summary: string;
  title: string;
  video: string;
  publishAt: number;
  coverSrc: string;
  abTesting: null;
  categoryId: number;
  categoryName: string;
  columnists: null;
  magazine: null;
  fundCategoryAbbr: string[];
  fbShare: number;
  fbComment: number;
  fbCommentPluginCount: number;
  market: {
    code: string;
    name: string;
    symbol: string;
  }[];
};

export type ResponseAiArticleTypeV2 = {
  items: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    next_page_url: string;
    prev_page_url: string;
    from: number;
    to: number;
    data: GETAiArticlesResponseV2[];
  };
  message: string;
  statusCode: number;
};

export type GETAiArticlesReturnResponseV2 = {
  items: PageData<GETAiArticlesResponseV2[]>;
  message: string;
  statusCode: number;
};

export enum AiCategory {
  AIGC_HOT = 'aigc_hot',
  HEADLINE_AI = 'headline_ai',
  TW_STOCK_AI = 'tw_stock_ai',
  WD_STOCK_AI = 'wd_stock_ai'
}

export type AiCategoryType =
  | AiCategory.AIGC_HOT
  | AiCategory.HEADLINE_AI
  | AiCategory.TW_STOCK_AI
  | AiCategory.WD_STOCK_AI;

export const AI_TABS: {
  category: AiCategoryType;
  name: string;
}[] = [
  { category: AiCategory.AIGC_HOT, name: '熱門' },
  { category: AiCategory.HEADLINE_AI, name: '頭條' },
  { category: AiCategory.TW_STOCK_AI, name: '台股' },
  { category: AiCategory.WD_STOCK_AI, name: '美股' }
];

export const sectionMap: Record<AiCategoryType, string> = {
  [AiCategory.AIGC_HOT]: 'News_Category_AIGC＿熱門QA',
  [AiCategory.HEADLINE_AI]: 'News_Category_頭條＿AI讀新聞',
  [AiCategory.TW_STOCK_AI]: 'News_Category_台股＿AI讀新聞',
  [AiCategory.WD_STOCK_AI]: 'News_Category_美股＿AI讀新聞'
};

export type ResponseAIGCHotItem = {
  created_at: string;
  link: string;
  question: string;
  source_url: string;
  views: number;
};

export type ResponseAIGCHot = {
  customer_id: string;
  generated_at: string;
  hot_qa: ResponseAIGCHotItem[];
};

export type GETAIGCHotItem = {
  createdAt: string;
  link: string;
  question: string;
  sourceUrl: string;
  views: number;
};

export type GETAIGCHotResponse = {
  customerId: string;
  generatedAt: string;
  hotQa: GETAIGCHotItem[];
};

export type GETAIGCAnswerMetaResponse = {
  title: string;
  description: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  jsonLd: [
    {
      '@context': string;
      '@type': string;
      mainEntity: {
        '@type': string;
        name: string;
        text: string;
        answerCount: number;
        datePublished: string;
        acceptedAnswer: {
          '@type': string;
          text: string;
          datePublished: string;
          url: string;
        };
      };
    }
  ];
  sourceUrl: string;
};
